export default {
  headerContent: {
    title: 'Quick Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Quick Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası aracınızı çarpma, çarpılma, yanma ve çalınma gibi birçok riske karşı güvence altına almaktadır.',
        'Bir araca sahip olmak artık bir lüks değil, daha çok bir gerekliliktir. Bir araç, hareket kabiliyetinizi artırır ve toplu taşımaya bağımlı olma ihtiyacını azaltır. Bununla birlikte, sürüşün kendine özgü tehlikeleri vardır. Sürüş sırasında disiplin eksikliği ve yolların kötü durumu genellikle kaza riskini artırır. Böyle talihsiz bir olay, aracınızın hasar görmesine neden olabilir ve ayrıca bedensel yaralanmalara ve ölüme neden olabilir. ',
        'Kendinizi bu tür olaylardan finansal olarak korumak için, bir araç / araba sigortası poliçesine yatırım yapmayı düşünebilirsiniz. ',
        'Quick Kasko Sigortası ile aracınızın maruz kalabileceği zararları güvence altına alabilirsiniz!'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Araç Kasko Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Kasko sigortası, trafik sigortası gibi zorunlu bir sigorta değildir. ',
          subList: null
        },
        {
          paragraph:
            'Aracınızın uğrayacağı maddi zararların karşılanması ve yaşayacağınız ekonomik kayıpların giderilmesi için Quick Kasko Sigortasını tercih ederek güvencenizi başlatabilirsiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
